/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Insert_EllipsisInputs */



/**
* | output |
* | --- |
* | "Insert ellipsis" |
*
* @param {Insert_EllipsisInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const insert_ellipsis = /** @type {((inputs?: Insert_EllipsisInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Insert_EllipsisInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Insérer des points de suspension")
	if (locale === "de") return /** @type {LocalizedString} */ ("Auslassungspunkte einfügen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci ellissi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вставить многоточие")
	if (locale === "es") return /** @type {LocalizedString} */ ("Insertar puntos suspensivos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("插入省略号")
	if (locale === "ja") return /** @type {LocalizedString} */ ("省略記号を挿入")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एलिप्सिस डालें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Inserir reticências")
	return /** @type {LocalizedString} */ ("Insert ellipsis")
});